// extracted by mini-css-extract-plugin
export default {"input":"EditorDefines_input__IXCXO"};